import { PlanPurchaseExperienceSummaryLineContainer } from './PlanPurchaseExperienceSummaryLineContainer'
import { PlanPurchaseExperienceSummaryLineLabel } from './PlanPurchaseExperienceSummaryLineLabel'
import { PlanPurchaseExperienceSummaryLineValue } from './PlanPurchaseExperienceSummaryLineValue'
import { ReactNode } from 'react'
import { getPriceText } from '../../../../utils/getPriceText'
import theme from '../../../../theme'

export interface PlanPurchaseExperienceSummaryLineProps {
  label: ReactNode
  appearance: 'primary' | 'secondary'
  priceInCents: number | string
}

export function PlanPurchaseExperienceSummaryLine(
  props: PlanPurchaseExperienceSummaryLineProps
): JSX.Element {
  if (props.priceInCents === 0) return <></>
  const isDiscount = typeof props.priceInCents === 'number' && props.priceInCents < 0
  const isPrimary = props.appearance === 'primary'
  const priceText =
    typeof props.priceInCents === 'number'
      ? getPriceText({ priceInCents: props.priceInCents })
      : props.priceInCents
  return (
    <PlanPurchaseExperienceSummaryLineContainer>
      <PlanPurchaseExperienceSummaryLineLabel appearance={props.appearance}>
        {props.label}
      </PlanPurchaseExperienceSummaryLineLabel>
      <PlanPurchaseExperienceSummaryLineValue
        appearance={props.appearance}
        color={isDiscount && isPrimary ? theme.colors.status.successDark : undefined}
      >
        {priceText}
      </PlanPurchaseExperienceSummaryLineValue>
    </PlanPurchaseExperienceSummaryLineContainer>
  )
}
